<ng-container *ngIf="credits.length > 1">
  <label *ngIf="showLabel" class="col-sm-4" translate>account_sms_default_type</label>
  <div [ngClass]="{ 'col-sm-8': showLabel }">
    <label class="radio-custom" *ngFor="let credit of credits" (click)="emitCreditType(credit.value)" for="{{ credit.value + randomId }}">
      <input
        type="radio"
        [value]="credit.value"
        [(ngModel)]="creditType"
        [checked]="credit.value === creditType"
        id="{{ credit.value + randomId }}"
        name="{{ credit.value + randomId }}"
      />
      <span class="radio-custom__radio"></span>
      <span class="radio-custom__label" *ngIf="credit.title">{{ credit.title }}</span>
      <span class="radio-custom__label" *ngIf="!credit.title">{{ 'credit_type_' + credit.value | lowercase | translate }}</span>
      <img class="ms-2 info-icon" [src]="credit.icon" alt="" />
    </label>
  </div>
</ng-container>
